import { useQuery } from "@tanstack/react-query";
import { programmeDashboardApi } from "../api/programmeDashboard";

export interface MonthlySpendTrendData {
  month: string;
  [portfolioName: string]: string | number;
}

const formatCurrency = (amount: number): number => {
  return amount / 1000000;
};

export const useMonthlySpendTrend = ({ portfolio_id, quickFilters }: { portfolio_id: string | undefined, quickFilters: any }) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["monthly-spend-trend", portfolio_id],
    queryFn: () => programmeDashboardApi.fetchMonthlySpendTrend(portfolio_id),
  });

  const chartData: MonthlySpendTrendData[] = [];

  if (data?.data) {
    const allMonths = new Set<string>();

    data.data.forEach((portfolio) => {
      portfolio.monthlySpend.forEach((spend) => {
        allMonths.add(spend.month);
      });
    });

    const sortedMonths = Array.from(allMonths).sort((a, b) => {
      const monthOrder = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return monthOrder.indexOf(a) - monthOrder.indexOf(b);
    });

    sortedMonths.forEach((month) => {
      const monthData: MonthlySpendTrendData = { month };

      data.data.forEach((portfolio) => {
        const spendData = portfolio.monthlySpend.find(
          (spend) => spend.month === month
        );
        monthData[portfolio.portfolio_name] = spendData
          ? formatCurrency(spendData.total_spend)
          : 0;
      });

      chartData.push(monthData);
    });
  }

  const portfolioNames = data?.data
    ? data.data.map((portfolio) => portfolio.portfolio_name)
    : [];

  return {
    chartData,
    portfolioNames,
    isLoading,
    isError,
    error:
      error instanceof Error
        ? error.message
        : "Failed to fetch monthly spend trend",
  };
};

